import { Entity, IUser, User } from '@app/core';
import { IMarketEntity } from '@games/interfaces';

export class MarketEntity extends Entity<IMarketEntity> {
  constructor(props: IMarketEntity) {
    super(props);
  }

  get id(): number {
    return this.props.id;
  }

  get name(): string {
    return this.props.name;
  }

  get index(): number {
    return this.props.index;
  }

  get players(): User[] {
    return this.props.players && this.props.players.map((player: IUser) => new User(player));
  }

  get playerNames(): string {
    return this.players.reduce(
      (playerNames: string, player: User) => playerNames + (playerNames ? ', ' : '') + player.name,
      ''
    );
  }

  get decisionUpdatedOn(): Date | null {
    return this.props.decisUpdate && new Date(this.props.decisUpdate);
  }

  get isDecisionsSaved(): boolean {
    return this.props.decisionsSaved;
  }

  getDecisionUpdatedOn(locale: string | string[]) {
    return (
      this.props.decisUpdate &&
      new Date(this.props.decisUpdate).toLocaleString(locale, {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      })
    );
  }
}
